import { Stock } from '@/entities/sales/Stock'

export class StockDocumentation extends Stock {

}
